import React from 'react'
import { Accordion } from 'react-bootstrap'
import { TimeSheetEditor } from './TSForm'

const TSFormMobile = ({ fdShifts, shiftDetail, activeAccordion, setActiveAccordion, formValues, onChangeTextInput }) => {
  return (
    <div className="only-mobile">
    <div className="all-leads-log mt30">
      {fdShifts?.length > 0 ? (
        fdShifts.map((shift, index) => (
          <div className="log-card" key={index}>
            <div className="all-info" style={{ rowGap: "1rem" }}>
              <div className="all-followuo-info-container pt-track-acc">
                <Accordion>
                  <Accordion.Item eventKey="0">
                    <div className="">
                      {shiftDetail?.slice(1).map((timeSlot, idx) => (
                        <Accordion key={idx}>
                          <Accordion.Item
                            eventKey={idx.toString()}
                            onClick={() =>
                              setActiveAccordion(
                                activeAccordion === idx ? null : idx
                              )
                            }
                          >
                            <Accordion.Header>
                              <div className="accordian_Header">
                                <h6>Shift Timing: {timeSlot}</h6>

                                <div className="accordion-icon">
                                  {idx === activeAccordion ? "-" : "+"}
                                </div>
                              </div>
                            </Accordion.Header>

                            <Accordion.Body>
                              <div className="label-value accordian_Body">
                                <div
                                  className="value"
                                  style={{
                                    minHeight: "150px",
                                    marginBottom: "15px",
                                  }}
                                >
                                  <TimeSheetEditor
                                    index={idx}
                                    value={formValues[idx]}
                                    onChange={(content) =>
                                      onChangeTextInput(content, idx)
                                    }
                                  />
                                </div>
                              </div>
                            </Accordion.Body>
                          </Accordion.Item>
                        </Accordion>
                      ))}
                    </div>
                  </Accordion.Item>
                </Accordion>
              </div>
            </div>
          </div>
        ))
      ) : (
        <span className=""></span>
      )}
    </div>
  </div>
  )
}

export default TSFormMobile